import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/task',
    children: [
      {
        index: true,
        element: LazyLoad(lazy(() => import('@/pages/task/home'))),
      },
      {
        path: 'rewards',
        element: LazyLoad(lazy(() => import('@/pages/task/rewards'))),
      },
    ],
  },
] as RouteObject[];
